export default "__VITE_ASSET__L7VcA5MA__"